import { HugeiconsIcon } from '@hugeicons/react'
import { Link01Icon } from '@hugeicons/core-free-icons'
import { cn } from '@/lib/utils'

export default function CustomLinksSection({ collapse }: { collapse: boolean }) {
  const links = window.hallway.universe.customLinks ?? []

  return (
    <>
      {links.map((link, index) => (
        <a
          key={index}
          href={link.url}
          target="_blank"
          rel="noreferrer"
          title={link.hint || link.label}
          className={cn(
            'flex shadow-none items-center transition-colors duration-500 bg-transparent m-0 rounded-lg gap-4 text-lg font-semibold cursor-pointer text-foreground hover:text-foreground hover:bg-accent',
            collapse
              ? 'w-12 h-12 p-3 [&_svg]:size-full'
              : 'justify-start w-full h-auto py-2 px-3 [&_svg]:size-5'
          )}
        >
          <HugeiconsIcon icon={Link01Icon} />
          {!collapse && <div className="truncate">{link.label}</div>}
        </a>
      ))}
    </>
  )
}
